<template>
  <ui-button
    block
    size="lg"
    class="quiz-result--button"
    :disabled="true"
    :class="getButtonClasses()"
  >
    <span class="quiz-result--text">{{ getButtonText() }}</span>
    <span class="quiz-result--point-wrapper" v-if="getPoint() !== null">
      <span class="quiz-result--point">+ {{ getPoint() | formatTotalPoint }}</span>
    </span>
  </ui-button>
</template>

<script>
import { mapState } from 'vuex'
import UiButton from '@/components/UI/Button'
import QuizStatuses from '@/constants/QuizStatuses'

const ANIMATE_DURATION = 1000

export default {
  components: {
    UiButton,
  },
  props: {
    // Response from /api/create-answer or /api/answer/quiz-result
    result: {
      type: Object,
      required: true,
    },

  },
  data() {
    return {
      point: null,
      updatePointInterval: null,
    }
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,

    }),
  },
  watch: {
    '$store.state.slide.quizStatus': function watchQuizStatus() {
      this.setPoint(this.result)
    },
    result: function watchResult(result) {
      this.setPoint(result)
    },
  },

  mounted() {
    this.setPoint(this.result)
  },
  destroyed() {
    if (this.updatePointInterval) {
      clearInterval(this.updatePointInterval)
    }
  },

  methods: {
    _getTextKey(result) {
      if (!result.correct) {
        if (!result.timeout) {
          return 'wrongAnswer'
        }
        return 'timesUp'
      }

      if (result.correct && result.typeCorrectAnswer !== 3) {
        return 'correctAnswer'
      }
      if (result.correct && result.typeCorrectAnswer === 3) {
        return 'partiallyCorrect'
      }
      return 'submit'
    },

    getButtonText() {
      return this.$t(this._getTextKey(this.result))
    },

    getButtonClasses() {
      if (this.result.correct) {
        return 'quiz-result--correct'
      }
      if (!this.result.correct) {
        return 'quiz-result--incorrect'
      }

      if (!this.result || this.slide.quizStatus === QuizStatuses.QUESTION_SCREEN) {
        return null
      }

      if (this.result.correct) {
        return 'quiz-result--correct'
      }
      if (!this.result.correct) {
        return 'quiz-result--incorrect'
      }

      return null
    },

    getPoint() {
      return this.point ? this.point : 0
    },

    setPoint(result) {
      if (!result || !result.id) return

      if (result.point === 0) {
        this.point = result.point
        return
      }
      setTimeout(() => {
        this.point = 0
        let elapsedTime = 0
        const fps = 1000 / 60
        const lastTime = Date.now()
        const increment = Math.ceil((result.point / ANIMATE_DURATION) * fps)

        this.updatePointInterval = setInterval(() => {
          elapsedTime = Date.now() - lastTime
          if (elapsedTime < ANIMATE_DURATION) {
            if (this.point + increment > result.point) {
              this.point = result.point
              clearInterval(this.updatePointInterval)
            } else {
              this.point += increment
            }
          } else {
            this.point = result.point
            clearInterval(this.updatePointInterval)
          }
        }, fps)
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.quiz-result--button {
  height: 48px;
  width: 100%;
  left: 18px;
  top: 8px;
  border-radius: 26px;
  padding: 11px, 43px, 11px, 43px;
  background: $primary-color;

  &:hover {
    background: darken($primary-color, 10%);
  }
}

.quiz-result--text {
  color: #fff;
  margin-right: 12px;
  text-transform: lowercase;
  font-weight: bold;
  &::first-letter {
    text-transform: uppercase;
  }
}

.quiz-result--point-wrapper {
  font-size: 0.875rem;
  padding: 8px;
  min-width: 65px;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  animation: fadeInUp;
  animation-duration: 0.5s;
  animation-timing-function: ease;
}

.quiz-result--point {
  display: inline-block;

}

.quiz-result--correct {
  background: $success-color;
  &:hover, &:disabled {
    background: $success-color;
  }
}
.quiz-result--incorrect {
  background: $failed-color;
  &:hover, &:disabled {
    background: $failed-color;
  }
}
</style>
